import React, { useRef } from "react";
import { Card, Container, Row, Table } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import _ from "lodash";
import { useQuery } from "react-apollo";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { GET_PAYMENT_GATEWAYS } from "../../graphql/query/GET_PAYMENT_GATEWAYS";
import { toggleRightSidebar } from "../../store/actions";
import PaymentGatewayItem from "./payment-gateway-item";

function SettingsPaymentGateway(props) {
  const [search, setSearch] = React.useState("");
  const [searchValue, setSearchValue] = React.useState("");
  const [isSearch, setIsSearch] = React.useState(false);
  const [newPayment, setNewPayment] = React.useState(false);

  const { data, loading, refetch } = useQuery(GET_PAYMENT_GATEWAYS, {
    variables: {
      paging: {
        first: 50,
      },
      filter: {
        isArchived: { is: false },
      },
      sorting: {
        field: "sequence",
        direction: "ASC",
      },
    },
    fetchPolicy: "network-only",
  });

  const debouncedSave = useRef(
    _.debounce((nextValue) => setSearch(nextValue), 300)
  ).current;

  return (
    <React.Fragment>
      <div className="page-content payment-type">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Settings" breadcrumbItem="Payment Gateways" />
          <div className="search-bar-container">
            <div className="button-add-user-container">
              {/* <div className="app-search d-none d-lg-block">
                <div className="position-relative">
                  <input
                    value={searchValue}
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                      debouncedSave(e.target.value);
                    }}
                  />
                  <span className="bx bx-search-alt"></span>
                </div>
              </div> */}
              <div className="d-flex">
                <div className="dropdown d-inline-block d-lg-none ml-2">
                  <button
                    type="button"
                    className="btn header-item noti-icon waves-effect"
                    id="page-header-search-dropdown"
                    onClick={() => {
                      setIsSearch(!isSearch);
                    }}
                  >
                    <i className="mdi mdi-magnify"></i>
                  </button>
                  <div
                    className={
                      isSearch
                        ? "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 show"
                        : "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
                    }
                    aria-labelledby="page-header-search-dropdown"
                  >
                    <form className="p-3">
                      <div className="form-group m-0">
                        <div className="input-group">
                          <input
                            value={searchValue}
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            onChange={(e) => {
                              setSearchValue(e.target.value);
                              debouncedSave(e.target.value);
                            }}
                          />
                          <div className="input-group-append">
                            <button className="btn btn-primary" type="submit">
                              <i className="mdi mdi-magnify"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="button-add-payment-container">
              <button
                type="button"
                className="waves-effect btn btn-outline-secondary button-payment-user"
                onClick={() => setNewPayment(true)}
              >
                <i className="bx bx-plus font-size-15 align-middle mr-2"></i>New
                Payment Gateway
              </button>
            </div> */}
          </div>
          <Row>
            {
              <Card className="w-100">
                <div className="table-responsive">
                  <Table className="table mb-0">
                    <thead>
                      <tr className="font-size-12">
                        <th>Name</th>
                        <th>Sequence</th>
                        <th>Payment Method Code</th>
                        <th>Transaction Type</th>
                        <th>Base Exchange Rate</th>
                        <th>Deposit Exchange Rate</th>
                        <th>Withdrawal Exchange Rate</th>
                        <th>Deposit Mark Up Rate</th>
                        <th>Withdrawal Mark Up Rate</th>
                        <th>Currency Pair</th>
                        <th>Active?</th>
                        <th>Archive</th>
                      </tr>
                    </thead>
                    <tbody className="table-body">
                      {data &&
                        data.paymentGateways.edges.length > 0 &&
                        data.paymentGateways.edges.map(
                          (paymentGateway, key) => (
                            <PaymentGatewayItem
                              key={key}
                              paymentGateway={paymentGateway}
                              refetch={refetch}
                            />
                          )
                        )}
                      {data && data.paymentGateways.edges.length === 0 && (
                        <tr className="text-center pb-2">
                          <td colSpan={12}>
                            <div className="no-user pt-0">
                              No Payment Gateway Found
                            </div>
                          </td>
                        </tr>
                      )}
                      {loading && (
                        <tr className="text-center pt-3">
                          <td colSpan={12}>
                            <Link to="#" className="text-success">
                              <i className="bx bx-hourglass bx-spin mr-2"></i>{" "}
                              Loading
                            </Link>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Card>
            }
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
  // }
}

const mapStatetoProps = (state) => {
  const { layoutType } = state.Layout;
  return { layoutType };
};

export default connect(mapStatetoProps, { toggleRightSidebar })(
  withTranslation()(SettingsPaymentGateway)
);
